import {useEffect} from 'react';

import _ from '../../utils/_';
import elementFactory from '../../utils/element';
import tabFactory from '../../../vendors/bootstrap/components/tab.js';
import './tab.scss';

const Tab = ({children, id}: propTypes) => {
  useEffect(() => {
    const $ = elementFactory(document, window);
    const triggers = $.findAll(`#${id} [data-toggle="tab"]`);
    const targets = [...triggers].map((x) => $.find($.getAttribute('href', x)));
    const tab = tabFactory($, _, document, window);
    const instance = tab(triggers, targets);
    return () => {
      instance.destroy();
    };
  }, [id]);

  return children;
};

interface propTypes {
  children: any;
  id: string;
}

export default Tab;
